export const isJsonArray = (data: string): boolean => {
  try {
    const parsed = JSON.parse(data);

    return Array.isArray(parsed);
  } catch {
    return false;
  }
};

export const isJsonArrayOfObjects = (data: string): boolean => {
  try {
    const parsed = JSON.parse(data);

    return (
      Array.isArray(parsed) &&
      parsed.every((item) => typeof item === "object" && item !== null)
    );
  } catch {
    return false;
  }
};
